import script from "./DatasetMoveDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetMoveDialog.vue?vue&type=script&setup=true&lang=js"

import "./DatasetMoveDialog.vue?vue&type=style&index=0&id=1d4e714e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d4e714e"]])

export default __exports__